import "./_style.less";
import {
  VuiButton,
  VuiContentLoading,
  VuiFormCard,
  VuiFormItem,
  VuiFormLayout,
  VuiNumberFormat,
  VuiSecondaryTitleWrapper,
} from "../../../../../@vendor/components";
import NumberFormat from "react-number-format";
import {
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import { useTranslation } from "react-i18next";
import { OrderSummary } from "../../../../../pages/app/Cart";
import { Cart } from "../../../../../models/Cart";
import {
  FC,
  FormEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { PaymentMethod } from "../../../../../models/PaymentMethod";
import PaymentMethodRepository from "../../../../../repositories/PaymentMethodRepository";
import {
  checkIsValidPhone,
  groupPaymentMethodHelper,
  handleErrorSaveDataResponse,
  showNotification,
  useIsMounted,
} from "../../../../../@vendor/utils";
import { RadioChangeEvent } from "antd/lib/radio/interface";
import { ListTextModal } from "../../../../atoms";
import moment from "moment";
import {
  IXenditCCResponse,
  IXenditError,
  IXenditTokenData,
} from "../../../../../@vendor/utils/interfaces/xendit.interface";
import BookingRepository from "../../../../../repositories/BookingRepository";
import { CreateBooking } from "../../../../../models/Booking";
import { AxiosError } from "axios";
import {
  ConfirmationModal,
  CreditCardAuthenticationModal,
} from "../../../modals";
import { RuleObject } from "antd/lib/form";
import { DEFAULT_PHONE_COUNTRY_CODE } from "../../../../../constants";
import PhoneInput from "../../../../../@vendor/components/atoms/PhoneInput";
// removed unused icon import
import GuestBookingRepository from "../../../../../repositories/GuestBookingRepository";
import BookingCounselingRepository from "../../../../../repositories/V2/BookingCounselingRepository";
import { saveGuestInfo } from "../../../../../@vendor/utils/helpers/local-storage.helper";
import { useBookingCounseling } from "../../../../../modules/booking-counseling/providers/booking-counseling.provider";
import { useBookingAssessment } from "../../../../../modules/booking-assessment/providers/booking-assessment.provider";

const Xendit = require("xendit-js-node");

const xenditApiKey = window._env_.REACT_APP_XENDIT_PUBLIC_KEY || "";

const { Text } = Typography;

interface ICartPaymentStep {
  orderSummary: OrderSummary;
  checkedCart: Cart[];
  onCheckout: (data: any) => void;
  isGuestMode?: boolean;
  guestBookingData?: {
    name: string;
    email: string;
    phone_number: string;
    phone_country: string;
    date_of_birth: string;
    bookings: {
      assessment_id?: number;
      session_amount?: number;
      price: number;
      is_package?: boolean;
      // For multi-session
      schedules?: {
        id: number;
        duration: number;
      }[];
      // For single session
      schedule_id?: number;
      duration?: number;
    }[];
  };
  guestCounselingBookingData?: any;
}

export interface IPaymentGroup {
  type_name: string;
  type_id: number;
  lists: PaymentMethod[];
}

export interface ICreditCard {
  card_number: string;
  payment_method_id: string;
  expired_date: string;
  cvv: string;
  card_holder_email?: string;
  card_holder_first_name?: string;
  card_holder_last_name?: string;
  card_holder_phone_number?: {
    phone?: string;
    code?: string;
  };
}

const CREDIT_CARD_TYPE_ID = 8;

const CartPaymentStep: FC<ICartPaymentStep> = ({
  orderSummary,
  checkedCart,
  onCheckout,
  isGuestMode = false,
  guestBookingData,
  guestCounselingBookingData,
}) => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const [form] = Form.useForm();
  const [xenditResponse, setXenditResponse] =
    useState<IXenditCCResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<PaymentMethod[]>([]);
  const [groupedData, setGroupedData] = useState<IPaymentGroup[]>([]);
  const [isFetchingData, setIsFetchingData] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<PaymentMethod | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [formData, setFormData] = useState<ICreditCard | null>(null);
  const [payerAuthUrl, setPayerAuthUrl] = useState<string | null>(null);
  const { resetForm, resetStep } = useBookingCounseling();
  const paymentMethodId = Form.useWatch("payment_method_id", form);
  const cardNumber = Form.useWatch("card_number", form);
  const cardExpired = Form.useWatch("expired_date", form);
  const cardCvv = Form.useWatch("cvv", form);
  const cardHolderFirstName = Form.useWatch("card_holder_first_name", form);
  const cardHolderLastName = Form.useWatch("card_holder_last_name", form);
  const cardHolderEmail = Form.useWatch("card_holder_email", form);
  const cardHolderPhoneNumber = Form.useWatch("card_holder_phone_number", form);

  const disabledCheckoutButton = useMemo(() => {
    if (selectedData?.type_id === CREDIT_CARD_TYPE_ID) {
      if (selectedData?.code === "VISA") {
        return (
          !cardNumber ||
          !cardExpired ||
          !cardCvv ||
          !cardHolderFirstName ||
          !cardHolderLastName ||
          !cardHolderEmail ||
          !cardHolderPhoneNumber?.phone
        );
      }
      return !cardNumber || !cardExpired || !cardCvv;
    }


    console.log(selectedData);

    return !selectedData?.id;
  }, [
    cardCvv,
    cardExpired,
    cardNumber,
    cardHolderEmail,
    cardHolderFirstName,
    cardHolderLastName,
    cardHolderPhoneNumber,
    selectedData?.id,
    selectedData?.type_id,
    selectedData?.code,
  ]);

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const loadData = useCallback(async () => {
    setIsFetchingData(true);

    await PaymentMethodRepository.findAll({
      with: ["paymentMethodInstructions", "logo", "type"],
    })
      .then((response) => {
        if (isMounted) {
          const { data: responseData } = response.data;
          setGroupedData(groupPaymentMethodHelper(responseData));
          setData(responseData);
          setIsFetchingData(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          setIsFetchingData(false);
        }
      });
  }, [isMounted]);

  const handleChangeRadio = useCallback(
    (event: RadioChangeEvent) => {
      const findItem = data.find((item) => item.id === event.target.value);
      if (findItem) {
        setSelectedData(findItem);
      }
    },
    [data]
  );

  const createBooking = useCallback(
    async (isXendit: boolean = false) => {
      if (selectedData) {
        if (isGuestMode) {
          if (guestBookingData) {
            const payload = {
              name: guestBookingData.name,
              email: guestBookingData.email,
              phone_number: guestBookingData.phone_number,
              phone_country: guestBookingData.phone_country,
              date_of_birth: guestBookingData.date_of_birth,
              payment_method_id: selectedData.id,
              bookings: guestBookingData.bookings.flatMap((booking) => {
                // Handle multi-session bookings with schedules
                if (booking.schedules) {
                  return booking.schedules.map((schedule) => ({
                    schedule_id: schedule.id,
                    category_id: undefined,
                    duration: schedule.duration,
                    price: booking.price,
                    assessment_id: booking.assessment_id,
                    session_amount: booking.session_amount,
                    is_package: booking.is_package,
                  }));
                }
                // Handle single session booking with schedule
                else if (booking.schedule_id && booking.duration) {
                  return [
                    {
                      schedule_id: booking.schedule_id,
                      category_id: undefined,
                      duration: booking.duration,
                      price: booking.price,
                      assessment_id: booking.assessment_id,
                      session_amount: booking.session_amount,
                      is_package: booking.is_package,
                    },
                  ];
                }
                // Handle assessment without schedule (no schedule_id, no duration)
                else {
                  return [
                    {
                      price: booking.price,
                      assessment_id: booking.assessment_id,
                      session_amount: booking.session_amount,
                      is_package: booking.is_package,
                      // Tidak ada schedule_id, category_id, duration
                    },
                  ];
                }
              }),
            };

            if (isXendit) {
              Object.assign(payload, {
                xendit_token_id: xenditResponse?.id,
                xendit_authentication_id: xenditResponse?.authentication_id,
                xendit_card_cvn: String(form.getFieldValue("cvv")),
              });

              if (selectedData?.code === "VISA") {
                const phoneNumber = form.getFieldValue(
                  "card_holder_phone_number"
                );
                Object.assign(payload, {
                  card_holder_first_name: String(
                    form.getFieldValue("card_holder_first_name")
                  ),
                  card_holder_last_name: String(
                    form.getFieldValue("card_holder_last_name")
                  ),
                  card_holder_email: String(
                    form.getFieldValue("card_holder_email")
                  ),
                  card_holder_phone_number: `+${phoneNumber?.code}${phoneNumber?.phone}`,
                });
              }
            }

            await GuestBookingRepository.createAssessment(payload)
              .then((response: any) => {
                const { data: responseData } = response.data;
                if (isMounted) {
                  setLoading(false);
                  onCheckout(responseData);
                }
              })
              .catch((error: AxiosError) => {
                if (isMounted) {
                  handleErrorSaveDataResponse(t, error);
                  setLoading(false);
                }
              });
          } else if (guestCounselingBookingData) {
            const payload = {
              name: guestCounselingBookingData.name,
              email: guestCounselingBookingData.email,
              phone_number: guestCounselingBookingData.phone_number,
              phone_country: guestCounselingBookingData.phone_country,
              date_of_birth: guestCounselingBookingData.date_of_birth,
              payment_method_id: selectedData.id,
              bookings: guestCounselingBookingData.bookings.flatMap(
                (booking: any) => {
                  if (booking.schedules) {
                    return booking.schedules.map((schedule: any) => ({
                      schedule_id: schedule.id,
                      category_id:
                        guestCounselingBookingData?.category_id ?? undefined,
                      duration: schedule.duration,
                      price: booking.price,
                      is_package: booking.is_package,
                    }));
                  } else if (booking.schedule_id && booking.duration) {
                    return [
                      {
                        schedule_id: booking.schedule_id,
                        category_id:
                          guestCounselingBookingData?.category_id ?? undefined,
                        duration: booking.duration,
                        price: booking.price,
                        session_amount: booking.session_amount,
                        is_package: booking.is_package,
                      },
                    ];
                  }

                  return [];
                }
              ),
            };

            if (isXendit) {
              Object.assign(payload, {
                xendit_token_id: xenditResponse?.id,
                xendit_authentication_id: xenditResponse?.authentication_id,
                xendit_card_cvn: String(form.getFieldValue("cvv")),
              });

              if (selectedData?.code === "VISA") {
                const phoneNumber = form.getFieldValue(
                  "card_holder_phone_number"
                );
                Object.assign(payload, {
                  card_holder_first_name: String(
                    form.getFieldValue("card_holder_first_name")
                  ),
                  card_holder_last_name: String(
                    form.getFieldValue("card_holder_last_name")
                  ),
                  card_holder_email: String(
                    form.getFieldValue("card_holder_email")
                  ),
                  card_holder_phone_number: `+${phoneNumber?.code}${phoneNumber?.phone}`,
                });
              }
            }

            await BookingCounselingRepository.create(payload)
              .then((response: any) => {
                const { data: responseData } = response.data;
                if (isMounted) {
                  setLoading(false);
                  onCheckout(responseData);
                }
              })
              .catch((error: AxiosError) => {
                if (isMounted) {
                  handleErrorSaveDataResponse(t, error);
                  setLoading(false);
                }
              });
          }

          saveGuestInfo({
            name:
              guestBookingData?.name || guestCounselingBookingData?.name || "",
            email:
              guestBookingData?.email ||
              guestCounselingBookingData?.email ||
              "",
            phone_number: {
              phone:
                guestBookingData?.phone_number ||
                guestCounselingBookingData?.phone_number ||
                "",
              code: Number(
                guestBookingData?.phone_country ||
                guestCounselingBookingData?.phone_country ||
                DEFAULT_PHONE_COUNTRY_CODE
              ),
            },
          });
        } else {
          // Regular cart booking for logged-in users
          const payload: CreateBooking = {
            payment_method_id: selectedData.id,
            bookings: checkedCart.map((cart) => {
              const isNoSchedule = !cart.is_package && !cart?.schedule_id;

              const data: any = {
                cart_id: cart.id,
                duration: isNoSchedule ? undefined : cart.duration,
                category_id: cart?.category_id ?? undefined,
                assessment_id: cart?.assessment_id ?? undefined,
                customer_id: cart.customer_id,
                price: cart.subtotal,
                is_package: isNoSchedule ? undefined : !!cart.is_package,
              };

              if (!cart.is_package && !isNoSchedule) {
                data.schedule_id = cart.schedule_id;
              }

              return data;
            }),
          };

          if (isXendit) {
            Object.assign(payload, {
              xendit_token_id: xenditResponse?.id,
              xendit_authentication_id: xenditResponse?.authentication_id,
              xendit_card_cvn: String(form.getFieldValue("cvv")),
            });

            if (selectedData?.code === "VISA") {
              const phoneNumber = form.getFieldValue(
                "card_holder_phone_number"
              );
              Object.assign(payload, {
                card_holder_first_name: String(
                  form.getFieldValue("card_holder_first_name")
                ),
                card_holder_last_name: String(
                  form.getFieldValue("card_holder_last_name")
                ),
                card_holder_email: String(
                  form.getFieldValue("card_holder_email")
                ),
                card_holder_phone_number: `+${phoneNumber?.code}${phoneNumber?.phone}`,
              });
            }
          }

          await BookingRepository.create(payload)
            .then((response) => {
              const { data: responseData } = response.data;
              if (isMounted) {
                setLoading(false);
                onCheckout(responseData);
              }
            })
            .catch((error: AxiosError) => {
              if (isMounted) {
                handleErrorSaveDataResponse(t, error);
                setLoading(false);
              }
            });
        }

        resetForm();
        resetStep();
      }
    },
    [
      selectedData,
      checkedCart,
      xenditResponse?.id,
      xenditResponse?.authentication_id,
      form,
      isMounted,
      onCheckout,
      t,
      isGuestMode,
      guestBookingData,
      guestCounselingBookingData,
    ]
  );

  const onFinish = useCallback(
    async (values: ICreditCard) => {
      setFormData(values);
      handleOpenModal();
    },
    [handleOpenModal]
  );

  const xenditTokenResponseHandler = (
    error: IXenditError | null,
    data: IXenditCCResponse
  ) => {
    setLoading(false);
    if (error) {
      showNotification("error", error.message);
    }

    if (data) {
      if (data.status === "VERIFIED") {
        setXenditResponse(data);
        setLoading(true);
      } else if (data.status === "IN_REVIEW") {
        setPayerAuthUrl(data.payer_authentication_url);
      } else if (data.status === "FAILED") {
        showNotification("error", data.failure_reason);
      }
    }
  };

  const handleCheckout = useCallback(() => {
    handleCloseModal();

    setLoading(true);

    if (selectedData?.type_id === 7) {
      createBooking().then();
    } else {
      const tax = orderSummary.subTotal * 0.11;
      const adminFee = orderSummary.subTotal * 0.029 + 6000;
      // Parse MM/YY format from masked input
      const expiredParts = formData?.expired_date?.split("/") || [];
      const expMonth = expiredParts[0] || "";
      const expYear = expiredParts[1] ? `20${expiredParts[1]}` : "";

      const tokenData: IXenditTokenData = {
        amount: Math.round(orderSummary.subTotal + adminFee + tax),
        card_number: String(formData?.card_number || "").replace(/\s/g, ""),
        card_exp_month: expMonth,
        card_exp_year: expYear,
        card_cvn: String(formData?.cvv),
        should_authenticate: true,
        currency: "IDR",
      };

      if (selectedData?.code === "VISA") {
        Object.assign(tokenData, {
          card_holder_email: formData?.card_holder_email,
          card_holder_first_name: formData?.card_holder_first_name,
          card_holder_last_name: formData?.card_holder_last_name,
          card_holder_phone_number: `+${formData?.card_holder_phone_number?.code}${formData?.card_holder_phone_number?.phone}`,
        });
      }

      Xendit.setPublishableKey(xenditApiKey);

      Xendit.card.createToken(tokenData, xenditTokenResponseHandler);
    }
  }, [
    formData,
    handleCloseModal,
    selectedData?.type_id,
    selectedData?.code,
    createBooking,
    guestCounselingBookingData,
    guestBookingData,
    isGuestMode,
    orderSummary.subTotal,
  ]);

  useEffect(() => {
    // Remove spaces from formatted card number
    const cleanCardNumber = String(cardNumber || "").replace(/\s/g, "");

    if (
      cleanCardNumber &&
      cleanCardNumber.length > 0 &&
      paymentMethodId === "credit_card"
    ) {
      if (cleanCardNumber[0] === "4") {
        const paymentMethodData = data.find((pm) => pm.code === "VISA");
        setSelectedData(paymentMethodData ?? null);
      } else if (["2", "5"].includes(cleanCardNumber[0])) {
        const paymentMethodData = data.find((pm) => pm.code === "MASTERCARD");
        setSelectedData(paymentMethodData ?? null);
      } else if (cleanCardNumber[0] === "3") {
        const paymentMethodData = data.find((pm) => pm.code === "JCB");
        setSelectedData(paymentMethodData ?? null);
      } else {
        setSelectedData(null);
      }
    }
  }, [cardNumber, paymentMethodId, data]);

  const validateCardNumber = (_: RuleObject, value: string) => {
    const item = t("common.form.cardNumber.label");
    // Remove spaces from formatted card number
    const cleanValue = String(value || "").replace(/\s/g, "");

    if (cleanValue) {
      // Check min 15 and max 16 digits
      if (cleanValue.length < 15) {
        return Promise.reject(
          new Error(
            t("validation.type.min", {
              item,
              min: 15,
            })
          )
        );
      }

      if (cleanValue.length > 16) {
        return Promise.reject(
          new Error(
            t("validation.type.max", {
              item,
              max: 16,
            })
          )
        );
      }

      if (selectedData) {
        if (selectedData.code === "VISA" && cleanValue[0] !== "4") {
          return Promise.reject(
            new Error(
              t("validation.visaCardNumberInvalid", {
                item,
              })
            )
          );
        }

        if (
          selectedData.code === "MASTERCARD" &&
          !["2", "5"].includes(cleanValue[0])
        ) {
          return Promise.reject(
            new Error(
              t("validation.mastercardCardNumberInvalid", {
                item,
              })
            )
          );
        }

        if (selectedData.code === "JCB" && cleanValue[0] !== "3") {
          return Promise.reject(
            new Error(
              t("validation.jcbCardNumberInvalid", {
                item,
              })
            )
          );
        }
      } else if (cleanValue.length >= 2) {
        return Promise.reject(
          new Error(
            t("validation.creditCardNumberInvalid", {
              item,
            })
          )
        );
      }
    }

    return Promise.resolve(true);
  };

  const renderTotal = useMemo(() => {
    const tax = orderSummary.subTotal * 0.11;
    const adminFee =
      selectedData?.type_id === CREDIT_CARD_TYPE_ID
        ? 6000 + orderSummary.subTotal * 0.029
        : 13000;
    const total = selectedData?.id
      ? orderSummary.subTotal + adminFee + tax
      : orderSummary.subTotal + tax;

    return (
      <>
        <ListTextModal
          label={`${t("common.text.subTotal")} ${checkedCart.length > 0
            ? t("common.text.schedulesItem", {
              item: checkedCart.length,
            })
            : ""
            }`}
          onlyFlex
          value={<VuiNumberFormat value={orderSummary.subTotal} />}
        />

        {selectedData ? (
          <>
            <ListTextModal
              label={t("common.text.paymentGatewayFee")}
              onlyFlex
              value={<VuiNumberFormat value={adminFee} />}
            />
          </>
        ) : null}

        <ListTextModal
          label={t("common.text.tax")}
          onlyFlex
          value={<VuiNumberFormat value={tax} />}
        />

        <Divider />

        <ListTextModal
          label={t("common.text.total")}
          labelTextWeight="bold"
          valueTextWeight="bold"
          onlyFlex
          value={<VuiNumberFormat value={total} />}
        />
      </>
    );
  }, [checkedCart.length, orderSummary.subTotal, selectedData, t]);

  useMemo(() => {
    (async () => {
      await loadData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useMemo(() => {
    if (xenditResponse) {
      createBooking(true).then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [xenditResponse]);

  useEffect(() => {
    console.log(paymentMethodId);
  }, [paymentMethodId]);

  return isFetchingData ? (
    <VuiContentLoading loading={isFetchingData} />
  ) : (
    <>
      <ConfirmationModal
        visible={showModal}
        onClose={handleCloseModal}
        onSubmit={handleCheckout}
        description={
          <p className="text-justify">
            Payment should be made within 30 minutes, or your booking will be
            automatically canceled.
            <br /> After your booking is confirmed,{" "}
            <strong>
              you cannot cancel your counseling appointment or get a refund
              payment
            </strong>
            . You can reschedule your appointment once, with the same
            psychologist and same duration at a{" "}
            <strong>maximum of 24 hours before your booked schedule</strong>.
          </p>
        }
        title={t("common.text.reminder")}
        submitBtnLabel={t("common.button.checkout")}
      />

      <div className="card-list" id="cart-payment-step">
        <Text className="card-payment-title">
          {t("common.text.choosePaymentMethod")}
        </Text>

        <VuiFormLayout
          form={form}
          onFinish={onFinish}
          onFinishFailed={() => {
            if (selectedData) {
              showNotification("warning", t("notification.error.inputInvalid"));
            } else {
              showNotification(
                "warning",
                t("notification.error.chooseYourItem", {
                  item: t("common.text.paymentMethod"),
                })
              );
            }
          }}
        >
          <VuiFormItem
            name={"payment_method_id"}
            rules={[
              {
                required: true,
                message: t("validation.required", {
                  item: t("common.form.paymentMethod.label"),
                }),
              },
            ]}
          >
            <Radio.Group style={{ width: "100%" }} onChange={handleChangeRadio}>
              {groupedData
                .filter((data) => data?.type_id !== CREDIT_CARD_TYPE_ID)
                .map((grouped) => {
                  return (
                    <VuiFormCard key={grouped.type_id}>
                      <Text className="cart-payment-step-text">
                        {grouped.type_name}
                      </Text>

                      <Divider style={{ marginBottom: 16, marginTop: 16 }} />

                      <Space direction="vertical" className="bank-payment-body">
                        {grouped.lists.map((list) => (
                          <Radio key={list.id} value={list.id}>
                            <div className="bank-payment-wrapper">
                              <div className="bank-payment-image">
                                <img
                                  src={list.logo?.url}
                                  alt={list.logo?.name}
                                />
                              </div>
                              <Text className="bank-payment-name">
                                {list.name}
                              </Text>
                              <Text>{list.description}</Text>
                            </div>
                          </Radio>
                        ))}

                        {selectedData?.type_id === CREDIT_CARD_TYPE_ID &&
                          grouped.type_id === CREDIT_CARD_TYPE_ID ? (
                          <div className="bank-payment-credit-card">
                            <Text className="bank-payment-credit-title">
                              {t("common.text.fillUsingCreditCard")}
                            </Text>
                            <VuiFormItem
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required", {
                                    item: t("common.form.cardNumber.label"),
                                  }),
                                },
                                {
                                  validator: validateCardNumber,
                                },
                              ]}
                              name={"card_number"}
                              label={t("common.form.cardNumber.label")}
                            >
                              <NumberFormat
                                format="#### #### #### ####"
                                placeholder="XXXX XXXX XXXX XXXX"
                                allowEmptyFormatting={false}
                                className="ant-input"
                              />
                            </VuiFormItem>

                            <div className="expiration-cvv-row">
                              <VuiFormItem
                                rules={[
                                  {
                                    required: true,
                                    message: t("validation.required", {
                                      item: t("common.form.expirationDate.label"),
                                    }),
                                  },
                                  {
                                    pattern: /^(0[1-9]|1[0-2])\/\d{2}$/,
                                    message: t("validation.invalidFormat", {
                                      item: t("common.form.expirationDate.label"),
                                      format: "MM/YY",
                                    }),
                                  },
                                ]}
                                name={"expired_date"}
                                label={t("common.form.expirationDate.label")}
                              >
                                <NumberFormat
                                  format="##/##"
                                  mask="_"
                                  placeholder="MM/YY"
                                  className="ant-input"
                                  allowEmptyFormatting={false}
                                />
                              </VuiFormItem>

                              <VuiFormItem
                                rules={[
                                  {
                                    required: true,
                                    message: t("validation.required", {
                                      item: t("common.form.cvv.label"),
                                    }),
                                  },
                                ]}
                                name={"cvv"}
                                label={t("common.form.cvv.label")}
                              >
                                <Input
                                  onInput={(e: FormEvent<HTMLInputElement>) => {
                                    return (e.currentTarget.value =
                                      e.currentTarget.value.replace(/\D/g, ""));
                                  }}
                                  placeholder={t("common.form.cvv.placeholder")}
                                  maxLength={4}
                                />
                              </VuiFormItem>
                            </div>

                            {selectedData?.code === "VISA" && (
                              <Row gutter={[16, 16]}>
                                <Col xs={24} md={12}>
                                  <VuiFormItem
                                    rules={[
                                      {
                                        required: true,
                                        message: t("validation.required", {
                                          item: t(
                                            "common.form.cardHolderEmail.label"
                                          ),
                                        }),
                                      },
                                      {
                                        type: "email",
                                        message: t("validation.type.email", {
                                          item: t(
                                            "common.form.cardHolderEmail.label"
                                          ),
                                        }),
                                      },
                                    ]}
                                    tooltip={t(
                                      "common.form.cardHolderEmail.tooltip"
                                    )}
                                    name={"card_holder_email"}
                                    label={t(
                                      "common.form.cardHolderEmail.label"
                                    )}
                                  >
                                    <Input
                                      placeholder={t(
                                        "common.form.cardHolderEmail.placeholder"
                                      )}
                                    />
                                  </VuiFormItem>
                                </Col>
                                <Col xs={24} md={12}>
                                  <VuiFormItem
                                    initialValue={{
                                      code: DEFAULT_PHONE_COUNTRY_CODE,
                                    }}
                                    rules={[
                                      {
                                        validator: (_, value) =>
                                          checkIsValidPhone(t, value),
                                      },
                                    ]}
                                    name={"card_holder_phone_number"}
                                    label={t("common.form.phone.label")}
                                  >
                                    <PhoneInput
                                      placeholder={t(
                                        "common.form.phone.placeholder"
                                      )}
                                    />
                                  </VuiFormItem>
                                </Col>
                                <Col xs={24} md={12}>
                                  <VuiFormItem
                                    rules={[
                                      {
                                        required: true,
                                        message: t("validation.required", {
                                          item: t(
                                            "common.form.cardHolderFirstName.label"
                                          ),
                                        }),
                                      },
                                    ]}
                                    tooltip={t(
                                      "common.form.cardHolderFirstName.tooltip"
                                    )}
                                    name={"card_holder_first_name"}
                                    label={t(
                                      "common.form.cardHolderFirstName.label"
                                    )}
                                  >
                                    <Input
                                      placeholder={t(
                                        "common.form.cardHolderFirstName.placeholder"
                                      )}
                                    />
                                  </VuiFormItem>
                                </Col>

                                <Col xs={24} md={12}>
                                  <VuiFormItem
                                    rules={[
                                      {
                                        required: true,
                                        message: t("validation.required", {
                                          item: t(
                                            "common.form.cardHolderLastName.label"
                                          ),
                                        }),
                                      },
                                    ]}
                                    tooltip={t(
                                      "common.form.cardHolderLastName.tooltip"
                                    )}
                                    name={"card_holder_last_name"}
                                    label={t(
                                      "common.form.cardHolderLastName.label"
                                    )}
                                  >
                                    <Input
                                      placeholder={t(
                                        "common.form.cardHolderLastName.placeholder"
                                      )}
                                    />
                                  </VuiFormItem>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ) : null}
                      </Space>
                    </VuiFormCard>
                  );
                })}

              <VuiFormCard key={CREDIT_CARD_TYPE_ID}>
                <Text className="cart-payment-step-text">Credit Card</Text>

                <Divider style={{ marginBottom: 16, marginTop: 16 }} />

                <Space direction="vertical" className="bank-payment-body">
                  <Radio key="credit_card" value="credit_card">
                    <div className="bank-payment-wrapper">
                      <Text className="bank-payment-name">Credit Card</Text>
                      <Text>Only accept payment from Credit Card</Text>
                    </div>
                  </Radio>

                  {paymentMethodId === "credit_card" ? (
                    <div className="bank-payment-credit-card">
                      <Text className="bank-payment-credit-title">
                        {t("common.text.fillUsingCreditCard")}
                      </Text>
                      <VuiFormItem
                        rules={[
                          {
                            required: true,
                            message: t("validation.required", {
                              item: t("common.form.cardNumber.label"),
                            }),
                          },
                          {
                            validator: validateCardNumber,
                          },
                        ]}
                        name={"card_number"}
                        label={t("common.form.cardNumber.label")}
                      >
                        <NumberFormat
                          format="#### #### #### ####"
                          placeholder="XXXX XXXX XXXX XXXX"
                          className="ant-input"
                        />
                      </VuiFormItem>

                      <div className="expiration-cvv-row">
                        <VuiFormItem
                          rules={[
                            {
                              required: true,
                              message: t("validation.required", {
                                item: t("common.form.expirationDate.label"),
                              }),
                            },
                            {
                              pattern: /^(0[1-9]|1[0-2])\/\d{2}$/,
                              message: t("validation.invalidFormat", {
                                item: t("common.form.expirationDate.label"),
                                format: "MM/YY",
                              }),
                            },
                          ]}
                          name={"expired_date"}
                          label={t("common.form.expirationDate.label")}
                        >
                          <NumberFormat
                            format="##/##"
                            mask="_"
                            placeholder="MM/YY"
                            className="ant-input"
                            allowEmptyFormatting={false}
                          />
                        </VuiFormItem>

                        <VuiFormItem
                          rules={[
                            {
                              required: true,
                              message: t("validation.required", {
                                item: t("common.form.cvv.label"),
                              }),
                            },
                          ]}
                          name={"cvv"}
                          label={t("common.form.cvv.label")}
                        >
                          <Input
                            onInput={(e: FormEvent<HTMLInputElement>) => {
                              return (e.currentTarget.value =
                                e.currentTarget.value.replace(/\D/g, ""));
                            }}
                            placeholder={t("common.form.cvv.placeholder")}
                            maxLength={4}
                          />
                        </VuiFormItem>
                      </div>

                      {selectedData?.code === "VISA" && (
                        <Row gutter={[16, 16]}>
                          <Col xs={24} md={12}>
                            <VuiFormItem
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required", {
                                    item: t(
                                      "common.form.cardHolderEmail.label"
                                    ),
                                  }),
                                },
                                {
                                  type: "email",
                                  message: t("validation.type.email", {
                                    item: t(
                                      "common.form.cardHolderEmail.label"
                                    ),
                                  }),
                                },
                              ]}
                              tooltip={t("common.form.cardHolderEmail.tooltip")}
                              name={"card_holder_email"}
                              label={t("common.form.cardHolderEmail.label")}
                            >
                              <Input
                                placeholder={t(
                                  "common.form.cardHolderEmail.placeholder"
                                )}
                              />
                            </VuiFormItem>
                          </Col>
                          <Col xs={24} md={12}>
                            <VuiFormItem
                              initialValue={{
                                code: DEFAULT_PHONE_COUNTRY_CODE,
                              }}
                              rules={[
                                {
                                  validator: (_, value) =>
                                    checkIsValidPhone(t, value),
                                },
                              ]}
                              name={"card_holder_phone_number"}
                              label={t("common.form.phone.label")}
                            >
                              <PhoneInput
                                placeholder={t("common.form.phone.placeholder")}
                              />
                            </VuiFormItem>
                          </Col>
                          <Col xs={24} md={12}>
                            <VuiFormItem
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required", {
                                    item: t(
                                      "common.form.cardHolderFirstName.label"
                                    ),
                                  }),
                                },
                              ]}
                              tooltip={t(
                                "common.form.cardHolderFirstName.tooltip"
                              )}
                              name={"card_holder_first_name"}
                              label={t("common.form.cardHolderFirstName.label")}
                            >
                              <Input
                                placeholder={t(
                                  "common.form.cardHolderFirstName.placeholder"
                                )}
                              />
                            </VuiFormItem>
                          </Col>

                          <Col xs={24} md={12}>
                            <VuiFormItem
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required", {
                                    item: t(
                                      "common.form.cardHolderLastName.label"
                                    ),
                                  }),
                                },
                              ]}
                              tooltip={t(
                                "common.form.cardHolderLastName.tooltip"
                              )}
                              name={"card_holder_last_name"}
                              label={t("common.form.cardHolderLastName.label")}
                            >
                              <Input
                                placeholder={t(
                                  "common.form.cardHolderLastName.placeholder"
                                )}
                              />
                            </VuiFormItem>
                          </Col>
                        </Row>
                      )}
                    </div>
                  ) : null}
                </Space>
              </VuiFormCard>
            </Radio.Group>
          </VuiFormItem>
        </VuiFormLayout>
      </div>

      <div className="cart-summary">
        <VuiSecondaryTitleWrapper title={t("common.text.orderSummary")} />

        <div style={{ marginBottom: 28, marginTop: 24 }}>{renderTotal}</div>

        <VuiButton
          buttonProps={{
            type: "primary",
            onClick: () => form.submit(),
            disabled: disabledCheckoutButton,
          }}
          loading={loading}
          label={t("common.button.checkout")}
        />
      </div>
      {Boolean(payerAuthUrl) && (
        <CreditCardAuthenticationModal
          visible={Boolean(payerAuthUrl)}
          onClose={() => setPayerAuthUrl(null)}
          onAuthenticated={(token) => xenditTokenResponseHandler(null, token)}
          authUrl={payerAuthUrl || ""}
        />
      )}
    </>
  );
};

export default CartPaymentStep;
